import Validation from '@core/logic/Validation'
import SavingsNeeds from '@master/model/kyc-form/need-analysis/savings/SavingsNeeds'
import { SavingsStructure } from '@company-common/model/kyc-form/needs-analysis/structure/savingInvestment/SavingsStructure'
import { Input } from '@core/model/structure/FNAStructure'

export default class SavingsNeedsValidation extends Validation {
  validate (savingsNeed: SavingsNeeds, belongsTo: string) {
    this.belongsTo = belongsTo
    const { getMessages, ADD, REQUIRE, WHEN } = this.validator()

    SavingsStructure(undefined).data
    // get only with validationMsg
      .filter(data => 'validationMsg' in data)
      .forEach(data => {
        const _data = data as Input<SavingsNeeds>
        ADD(WHEN(savingsNeed.plan, REQUIRE(savingsNeed[_data.key], _data.validationMsg)), ['Needs Analysis Calculation'], [_data.key])
      })
    return getMessages()
  }
}
